export const DATMEER_CONNECTION = 'DatameerConnection';
export const LOCAL_FILE_CONNECTION = 'LocalFileConnection';
export const SNOWFLAKE_CONNECTION = 'SnowflakeConnection';
export const UPLOAD_CONNECTION = 'UploadConnection';
